<template>
  <div style="padding: 10px">
      <el-row class="box2" >
        <el-col :span="8">出库仓库：{{formData.out_store_name}}</el-col>
        <el-col :span="8">发货日期：{{formData.send_date}}</el-col>
        <el-col :span="8">创建人：{{formData.create_user_name}}</el-col>
      </el-row>
      <el-row class="box2" >
        <el-col :span="8">到达仓库：{{formData.in_store_name}}</el-col>
        <el-col :span="8">单据状态：{{formData.status_name}}</el-col>
      </el-row>
      <el-row class="box2" >
        <el-col :span="24">出库备注：{{formData.remark}}</el-col>
      </el-row>

      <el-row class="box">
        <el-col :span="4" style="text-align:left">物料编码</el-col>
        <el-col :span="7" style="text-align:left">物料名称</el-col>
        <el-col :span="3">发货数量</el-col>
        <el-col :span="3">接收数量</el-col>
        <el-col :span="3">批次</el-col>
        <el-col :span="4">入库库位</el-col>
      </el-row>

      <div style="height:290px;overflow-y: auto;overflow-x: hidden">
        <el-row v-for="item in formData.item_list" :key="item.id" class="row" :gutter="10">
          <el-col :span="4">
            {{item.material_code}}
          </el-col>
          <el-col :span="7">
            {{item.material_name}}
          </el-col>
          <el-col :span="3">
            {{item.send_cnt}}
          </el-col>
          <el-col :span="3">
            <el-input-number v-model="item.receive_cnt" class="form-item" placeholder="接收数量" clearable style="width: 100%"></el-input-number>
          </el-col>
          <el-col :span="3">
            {{item.batch_no}}
          </el-col>
          <el-col :span="4">
            <el-select v-model="item.in_location_id" class="form-item" placeholder="入库库位" clearable style="width: 100%">
              <el-option v-for="location in formData.location_list" :key="location.id" :label="location.code" :value="location.id"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>

      <el-row style="margin-top: 15px">
        <el-col :span="24">
          <el-input type="textarea" class="quote-remark" v-model="formData.receive_remark" placeholder="接收备注" style="width: 100%" :autosize="true"></el-input>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button type="primary" style="width: 500px;margin-top: 10px" @click="receive" :loading="loading">接收入库</el-button>
      </el-form-item>

  </div>
</template>

<script>
export default {
  name: "ReceiveTransfer",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        request_id: '',
        create_user_name: '',
        create_time: '',
        status_name: '',
        status: '',
        item_list: [],
        location_list: [],
      },
      loading: false
    }
  },
  computed: {
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo(){
      let transferId = this.parentData.id;
      this.formData = await this.$http('wmsTransferService.getDetailForReceive', {id:transferId});
    },
    async receive() {
      for (let i = 0; i < this.formData.item_list.length; i++) {
        let obj = this.formData.item_list[i]
        if (!obj.in_location_id || obj.in_location_id == '') {
          return this.$message.error("未输入库位");
        }
      }

      await this.$http('wmsTransferService.receive', this.formData);
      this.$message.success("提交成功");
      this.$fn.closeWindow();
      this.$fn.search();
      this.getInfo();
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 240px;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: left;
}

.box2 {
  height: 35px;
  line-height: 35px;
  text-align: left;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-90 {
  width: 90%;
}

.w100 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>